import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonApi } from '../+api';
import { ConceptYearInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class ConceptYearService {
  constructor(private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<ConceptYearInterface[]> {
    return this.personApi
      .getData(userId, 'conceptYears')
      .pipe(map((res: { conceptYears: ConceptYearInterface[] }) => res.conceptYears));
  }
}
